import { connect } from "react-redux";
import UpgradesReview from "src/components/ContinueDeal/UpgradesReview";
import { GapInsurance, ServiceAndProtection } from "src/components/ContinueDeal/UpgradesReview/UpgradesReview";
import { getVehicle } from "src/store/selectors/vehicles";
import { VehicleState } from "Types/state";
import { ApplicationStore } from "../store/";

function mapStateToProps(state: ApplicationStore, { vin }: { vin: string }) {
    const vehicle = getVehicle(state, vin) as VehicleState & {
        services?: ServiceAndProtection[];
        insurances?: GapInsurance[];
    };

    return {
        accessories: vehicle.accessories || [],
        insurances: vehicle.insurances || [],
        monthlyPayments: 999.99, // TODO: missing wiring
        onlyShowAccessories: true, // TODO: should be remove, once services and insurances are done
        services: vehicle.services || [],
    };
}

const mapDispatchToProps = () => ({
    onInsuranceRemove: (id: number) => void 0, // TODO: missing wiring
    onServiceRemove: (id: number) => void 0, // TODO: missing wiring
});

export default connect(mapStateToProps, mapDispatchToProps)(UpgradesReview);
